"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isNotEmpty = exports.isWebhook = exports.hasAbis = void 0;
var hasAbis = function (webhookData) {
    if (!webhookData.abi || webhookData.abi.length < 1) {
        return false;
    }
    return true;
};
exports.hasAbis = hasAbis;
var isWebhook = function (webhookData) {
    if (typeof webhookData !== 'object' || webhookData === null || !('logs' in webhookData)) {
        return false;
    }
    return true;
};
exports.isWebhook = isWebhook;
var isNotEmpty = function (value) { return value !== null && value !== undefined; };
exports.isNotEmpty = isNotEmpty;
//# sourceMappingURL=logDecoderUtils.js.map